import { useCallback } from "react";

import type { ReservationLocalCancelFeeAcceptInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationLocalCancelFeeTransferAccept = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationLocalCancelFeeTransferAccept: _onUpdateReservationLocalCancelFeeTransferAccept } =
		MutationRepository.useReservationLocalCancelFeeTransferAcceptUpdateMutation();

	/**
	 * 予約詳細の現地決済の承認の承認への更新を実行
	 */
	const onUpdateReservationLocalCancelFeeTransferAccept = useCallback(async () => {
		const input: ReservationLocalCancelFeeAcceptInput = {
			hotelID,
			reservationID,
		} satisfies ReservationLocalCancelFeeAcceptInput;
		await _onUpdateReservationLocalCancelFeeTransferAccept(input);
	}, [_onUpdateReservationLocalCancelFeeTransferAccept, hotelID, reservationID]);

	return {
		onUpdateReservationLocalCancelFeeTransferAccept,
	};
};
